import { setItem } from '@/utils/StorageManager'

export default {
  SET_CURRENT_STEP(state, payload) {
    state.currentStep = payload
    setItem('stateStep', JSON.stringify(state))
  },

  SET_COSTUMER(state, payload) {
    state.customer = payload
    setItem('stateStep', JSON.stringify(state))
  },

  SET_CARD(state, payload) {
    state.card = payload
    setItem('stateStep', JSON.stringify(state))
  },

  SET_INFO_STEP(state, data) {
    for (var key in data) {
      state[key] = data[key]
    }

    setItem('stateStep', JSON.stringify(state))
  },

  SET_PROP_INFO_STEP(state, { prop, data }) {
    state[prop] = data
    setItem('stateStep', JSON.stringify(state))
  },

  SET_MODAL(state, { modalName, componentName, messageModal }) {
    state.messageModal = ''
    if (messageModal) state.messageModal = messageModal

    if (modalName == 'modalPlanDetails') {
      state.modalPlanDetails = true
      return
    }

    if (modalName && componentName) {
      state[modalName] = true
      state.componentOpenedInModal = componentName
      return
    }

    state.messageModal = messageModal
    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStep', JSON.stringify(state))
  },

  CLOSE_MODAL(state) {
    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStep', JSON.stringify(state))
  },

  CLOSE_MODALa(state) {
    state.componentOpenedInModal = null
    state.modalPlanDetails = false
    state.modalpayment = false
    setItem('stateStep', JSON.stringify(state))
  },

  RESET_STEP(state) {
    state.currentStep = 1
    state.maxStep = 1
    state.modalPlanDetails = false
    state.modalpayment = false
    state.componentOpenedInModal = null
    state.maxAudience = 500
    state.maxEmailsIncluded = 2000
    state.selectedPlanId = ''
    state.selectedPlanName = ''
    state.paymentPeriod = 1
    state.mount = 0
    state.tax = 0
    state.subTotal = 0
    state.totalPrice = 0
    state.setupIntent = null
    state.setupIntentClientSecret = null
    state.card = null
    localStorage.removeItem('stateStep')
  },

  RESET_PAYMENT(state) {
    state.tax = 0
    state.subTotal = 0
    state.totalPrice = 0
    state.setupIntent = null
    state.setupIntentClientSecret = null
    state.card = null
    setItem('stateStep', JSON.stringify(state))
  },
}
